<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblEditMechanic</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between  bg-grey">
        <ul ngbNav #nav="ngbNav" class="nav-tabs">
          <li *ngFor="let tab of tabs" class="nav-item" >
            <a translate class="nav-link" (click)="selectedtab=tab.id" [ngClass]="{'active': selectedtab===tab.id}">{{tab.label}}</a>
          </li>
        </ul>
        <div class="fs-16px mr-4">
          <ng-cotainer *ngIf="selectedtab" class="clrBlue text-capitalize">
              <em class="fas fa-user mr-2"></em>{{mechanicName}}
            </ng-cotainer>
        </div>
      </div>
      <div [ngbNavOutlet]="nav" class="tab-content"></div>
    </div>
  </div>

</div>
  <ng-cotainer *ngIf="selectedtab===1">
    <app-edit-basic-details-mechanic></app-edit-basic-details-mechanic>
  </ng-cotainer>
  <ng-cotainer *ngIf="selectedtab===2">
    <app-edit-competence-mechanic></app-edit-competence-mechanic>
  </ng-cotainer>
  <ng-cotainer *ngIf="selectedtab===3">
    <app-edit-hours-mechanic></app-edit-hours-mechanic>
  </ng-cotainer>
  <ng-cotainer *ngIf="selectedtab===6">
    <app-edit-customer-waiting-hours-mechanic></app-edit-customer-waiting-hours-mechanic>
  </ng-cotainer>
  <ng-cotainer *ngIf="selectedtab===4">
    <app-edit-leaves-mechanic></app-edit-leaves-mechanic>
  </ng-cotainer>
  <ng-cotainer *ngIf="selectedtab===5">
    <app-mechanic-recipient-list></app-mechanic-recipient-list>
  </ng-cotainer>


